import KmRadio from './main.vue'
KmRadio.install = function (vue) {
  vue.component(KmRadio.name, KmRadio)
}
export default KmRadio



// WEBPACK FOOTER //
// ./src/ui/components/radio/index.js